import React, { Component } from 'react'
import {
  Grid, Row, Col
} from 'react-bootstrap'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import { style } from '../../variables/Variables'
import bitrixConfig from '../../bitrixConfig.json'

const env = process.env.REACT_APP_BTX_CONFIG || 'development'

class Login extends Component {
  constructor (props) {
    super(props)
    this.onLogin = props.onLogin.bind(this)
    this.notificationSystem = React.createRef()
  }

  componentDidMount () {
    if (window.location.pathname === '/login' && !window.location.search) {
      const currentPath = window.sessionStorage.getItem('redirectUrl')
      if (!currentPath) {
        window.sessionStorage.setItem('redirectUrl', encodeURIComponent('/'))
      }
    }
  }

  renderButtons () {
    const sessionRedirect = window.sessionStorage.getItem('redirectUrl') || '/'
    return (
      <div>
        <a className='btn-block btn btn-lg btn-default' href={`https://cube.bitrix24.pl/oauth/authorize?response_type=code&client_id=${bitrixConfig[env]?.client_id}&redirect_uri=${bitrixConfig[env]?.redirect_uri}/api/oauth2/bitrix?url=${sessionRedirect}`}>Logowanie przez konto Bitrix</a>
      </div>
    )
  }

  render () {
    console.log('process.env.REACT_APP_BTX_CONFIG', process.env.REACT_APP_BTX_CONFIG)
    console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    console.log('process.env.REACT_APP_NODE_ENV', process.env.REACT_APP_NODE_ENV)
    return (
      <div className='content'>
        <NotificationSystem ref={this.notificationSystem} style={style} />
        <Grid fluid>
          <Row>
            <Col md={8}>
              {this.renderButtons()}
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = {
  onLoginSubmit: id => ({
    type: 'INIT_LOGIN'
  }),
  onLogin: user => ({
    type: 'SET_USER',
    user
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
